import { type ReactElement, type ReactNode } from 'react'

interface Props {
  label: string
  required?: boolean
  hint?: string
  children: ReactNode
}

export function FormField ({ label, required, hint, children }: Props): ReactElement {
  return (
    <div className='mb-4.5'>
      <div className='text-xs font-semibold text-muted-foreground tracking-[0.03em] mb-1.25'>
        {label}
        {required === true && <span className='text-destructive'> *</span>}
      </div>
      {children}
      {(hint != null && hint !== '') && <div className='text-[11px] text-(--bp-ink3) mt-1'>{hint}</div>}
    </div>
  )
}
